module.exports = __webpack_public_path__ + "static/media/SAS Chat Tone 1.b22988e4.wav";